// extracted by mini-css-extract-plugin
export var centerText = "_c1-8";
export var container = "_c1-0";
export var doughnutContainer = "_c1-7";
export var legend = "_c1-a";
export var legendItemColorDisplay = "_c1-b";
export var legendItemLabel = "_c1-d";
export var legendItemValue = "_c1-c";
export var lg = "_c1-5";
export var maxWidth = "_c1-9";
export var md = "_c1-4";
export var responsive = "_c1-6";
export var sm = "_c1-3";
export var xs = "_c1-2";
export var xxs = "_c1-1";